<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">单位类型</div>
          <div class="field">
            `<el-select v-model="query.comtype" :clearable="true" placeholder="请选择">
              <el-option v-for="item in roles" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">单位名称</div>
          <div class="field">
            <el-input v-model.trim="query.comcodename" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">联系电话</div>
          <div class="field">
            <el-input v-model.trim="query.commobile" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false" :showPage="true" :resizable="true"
      :total="query.total" :needBlackRow="false" :needPopMenu="false" :canbeEdit="false" @cellClick="cellClick"
      @cellDblClick="viewProject" @pagechange="pagechange" :isOperate="btn.isOperate" :operateBtn="btn.right"
      @vggridClick="vggridClick">
      <!--<template slot="btn">-->
      <!--<menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>-->
      <!--</template>-->
    </vggrid>
    <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="dialogVisible" width="70%">
      <div>
        <el-form :model="newCom" ref="ruleForm" label-position="right" class="mainfrom from_input">
          <div class="view-container">
            <div class="view-box">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">单位名称</div>
                  <div class="view-value">{{ newCom.comfullname }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">单位类型</div>
                  <div class="view-value">{{ newCom.comtypename }}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">统一信用代码</div>
                  <div class="view-value">{{ newCom.comidcode }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">手机号码</div>
                  <div class="view-value">{{ newCom.commobile }}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">联系人</div>
                  <div class="view-value">{{ newCom.comcontact }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">营业执照</div>
                  <div class="view-value">
                    <!-- <popover-img :img-src="newCom.appendurl ? uploadAddr + newCom.appendurl : ''" default-height="150">
                    </popover-img> -->
                    <ELimage :secUrl="newCom.appendurl ? uploadAddr + newCom.appendurl : ''" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-form-item label="审批状态" verify>
            <div class="radio_w">
              <el-radio v-model="newCom.cositemcomstatus" :label="3">合格</el-radio>
              <el-radio v-model="newCom.cositemcomstatus" :label="1">不合格</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="审批意见">
            <el-input type="textarea" :autosize="{ minRows: 5 }" v-model.trim="newCom.cositemappcomm" :maxlength="255"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <vxe-button type='primary' class="vxe-btn" @click="save">保存</vxe-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="showView" width="70%">
      <div>
        <el-form :model="com" ref="ruleForm" label-position="right" class="mainfrom from_input">
          <div class="view-container">
            <div class="view-box">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">单位名称</div>
                  <div class="view-value">{{ com.comfullname }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">单位类型</div>
                  <div class="view-value">{{ com.comtypename }}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">统一信用代码</div>
                  <div class="view-value">{{ com.comidcode }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">手机号码</div>
                  <div class="view-value">{{ com.commobile }}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">联系人</div>
                  <div class="view-value">{{ com.comcontact }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">营业执照</div>
                  <div class="view-value">
                    <!-- <popover-img :img-src="com.appendurl ? uploadAddr + com.appendurl : ''" default-height="150">
                    </popover-img> -->
                    <ELimage :secUrl="com.appendurl ? uploadAddr + com.appendurl : ''" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-form-item label="审批状态" verify>
            <div class="radio_w">
              {{ +com.cositemcomstatus === 1 ? "注册" : (+com.cositemcomstatus === 2 ? "待审" : "不合格") }}
            </div>
          </el-form-item>
          <el-form-item label="审批意见">
            <div v-text="com.cositemappcomm"></div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import common from '@/mixin/common'
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import popoverImg from '../common/popoverImg'
import uploadPicOne from '../common/uploadPicOne'
import ELimage from '../component/ELimage'
export default {
  name: 'comIndex',
  mixins: [common],
  data() {
    return {
      dialogVisible: false,
      menuid: this.$route.query.menuid,
      btn: {},
      list: [],
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
        { field: 'comtypename', fieldtype: 'C', title: '单位类型', calculExpr: '', addNewRowFlg: false },
        { field: 'comfullname', fieldtype: 'C', title: '单位名称', calculExpr: '', addNewRowFlg: false },
        { field: 'comcontact', fieldtype: 'C', title: '联系人', calculExpr: '', addNewRowFlg: false },
        { field: 'commobile', fieldtype: 'C', title: '联系电话', calculExpr: '', addNewRowFlg: false, width: 120 },
        { field: 'comregtime', fieldtype: 'T', title: '注册日期', calculExpr: '', width: 150, addNewRowFlg: false, formatter: ['toDateString', ''] },
        { field: 'cositemapsynergywaydesc', fieldtype: 'C', title: '与代理协同方式', width: 120, calculExpr: '', addNewRowFlg: false },
        {
          title: '状态 ', width: 90, showOverflow: true,
          slots: {
            default: 'default',
            default: ({ row }) => {
              if (+row.cositemcomstatus === 2) {
                return '待审'
              }
              if (+row.cositemcomstatus === 1) {
                return '注册'
              }
              if (+row.cositemcomstatus === 4) {
                return '不合格'
              }
            }
          }
        },
        {
          title: '操作 ', width: 90, showOverflow: true,
          slots: {
            default: 'default',
            default: ({ row }) => {
              if (+row.cositemcomstatus === 2) {
                return [<vxe-button type='primary' onClick={this.goCheck.bind(this, row)}>审核</vxe-button>]
              } else {
                return [<vxe-button type='primary' onClick={this.toView.bind(this, row)}>查看</vxe-button>]
              }
            }
          }
        }
      ],
      comform: false,
      showView: false,
      com: {},
      newCom: {},
      query: {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: ''
      },
      roles: []
    }
  },
  created() {
  },
  activated() {
    this.init()
    this.getSysCodeList()
    this.getPageList()
  },
  mounted() {
  },
  watch: {
    async '$route'() {
      this.getPageList()
    }
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    }
  },
  components: { MenuBtn, vggrid, uploadPicOne, popoverImg, ELimage },
  methods: {
    async save() {
      if (!this.newCom.cositemcomstatus) {
        this.$message.warning('请选择审批状态!')
        return
      }
      if (+this.newCom.cositemcomstatus === 4 && !this.newCom.cositemappcomm) {
        this.$message.warning('请填写审批意见!')
        return
      }
      this.newCom.cosid = this.$store.getters.loginUser.cosid
      this.$confirm(`审批状态为${+this.newCom.cositemcomstatus === 3 ? '合格' : '不合格'}，是否继续保存`, '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(async () => {
        let data = await request({
          url: '/ywgl/com/updateComStatus',
          method: "post",
          data: this.newCom
        })
        if (data.issuccess === 1) {
          this.dialogClose()
          this.regPush()
          this.sms()
          this.getPageList()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      }).catch(() => { })
    },
    async sms() {
      await request({
        url: '/sms/send',
        method: 'get',
        params: {
          type: '3',
          tel: this.newCom.usercode,
          cosname: this.$store.getters.loginUser.cosname,
          status: this.newCom.cositemcomstatus
        }
      })
    },
    async regPush() {
      let model = {}
      model.cositemcomstatus = this.newCom.cositemcomstatus
      model.cosid = this.$store.getters.loginUser.cosid
      model.userid = this.newCom.cositemuserid
      await request({
        url: '/info/rush/regApprove',
        method: "get",
        params: model
      })
    },
    dialogClose() {
      this.dialogVisible = false
    },
    toView() {
      // showView
      this.showView = true
    },
    goCheck(row) {
      this.com = row
      this.dialogVisible = true
      this.newCom = {
        comid: row.comid,
        usercode: row.comusercode,
        cositemid: row.cositemid,
        userid: this.$store.getters.loginUser.userid,
        cositemuserid: row.cositemuserid,
        comtype: row.cositemcomtype,
        comfullname: row.comfullname,
        comtypename: row.comtypename,
        comidcode: row.comidcode,
        commobile: row.commobile,
        comcontact: row.comcontact,
        appendurl: row.appendurl
      }
    },
    init() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: ''
      }
    },
    async getSysCodeList() {
      let res = await request({
        method: 'get',
        url: '/kfgl/syscode/getSysCodeList',
        params: { syscode: 'cositemcomtype' }
      })
      this.roles = res
    },
    vggridClick(code, row) {
      this.com = row
      this.$emit(code, row)
    },
    async cellClick(row) {
      this.com = row.row
    },
    async viewProject(row) {
      this.com = row.row
      this.$router.push({ name: 'comView', params: { comid: this.com.comid, innerbtn: this.btn.inner } })
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      this.getPageList()
    },
    async getPageList() {
      this.loading = true
      this.query.isWarehousing = true
      let res = await request({
        method: 'get',
        url: '/ywgl/com/getRegCheckPageList',
        params: this.query
      })
      this.list = res.list
      this.query.total = res.count[0].count
      this.loading = false
    }
  },
  filters: {
  }
}
</script>

<style lang="scss" scoped>
.main {

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }
}
</style>
